/**
 * Accordion class.
 */
class SingleAccordion {
    /**
     * Construct current accordion
     * @param el
     */
    constructor(el) {
        this.el = el;
        this.toggles = this.el.querySelectorAll('[data-accordion-toggle]');
        this.content = this.el.querySelector('[data-accordion-content]');

        this.toggles.forEach((el) => {
            el.addEventListener('click', this._toggleListener.bind(this));
        });
        this.content.style.setProperty('--accordion-height', this.content.scrollHeight + 'px');

        setTimeout(() => {
            this.setContentHeight();
        }, 1000);

        window.addEventListener('resize', () => {
            this.setContentHeight();
        });

        document.addEventListener('accordionOpen', this._accordionOpenListener.bind(this));

        document.documentElement.addEventListener('smoothscroll', (e) => {
            this.smoothScroll = e.detail.SmoothScroll;

            if (
                this.el.contains(e.detail.SmoothScroll.scrollToElement)
                || this.el === e.detail.SmoothScroll.scrollToElement
                || this.el.parentNode === e.detail.SmoothScroll.scrollToElement
            ) {
                if (!this.isOpen()) {
                    e.preventDefault();

                    this._endListener = this._endListener.bind(this);
                    this.content.addEventListener('transitionend', this._endListener);

                    this.open();
                }
            }
        });
    }

    /**
     * Set content height of item.
     */
    setContentHeight() {
        this.content.style.setProperty('--accordion-height', this.content.scrollHeight + 'px');
    }

    /**
     * Transition end listener.
     * @private
     */
    _endListener() {
        this.smoothScroll.scrollTo(this.el);
        this.content.removeEventListener('transitionend', this._endListener);
    }

    /**
     * Listen for other accordion opening.
     * @param e
     * @private
     */
    _accordionOpenListener(e) {
        if (e.detail !== this) {
            this.close();
        }
    }

    /**
     * Handle click events.
     * @private
     */
    _toggleListener() {
        if (this.el.classList.contains('is-active')) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Open current accordion.
     */
    open() {
        this.setContentHeight();
        this.el.classList.add('is-active');

        document.dispatchEvent(new CustomEvent('accordionOpen', {
            detail: this,
        }));
    }

    /**
     * Close current accordion.
     */
    close() {
        this.el.classList.remove('is-active');
    }

    /**
     * Check if accordion is open.
     * @returns {*}
     */
    isOpen() {
        return this.el.matches('.is-active');
    }
}

/**
 * Accordion group class
 */
class Accordions {
    /**
     * Construct accordion group.
     * @param container
     */
    constructor(container) {
        this.container = container;
        this.nlAccordions = container.querySelectorAll('[data-accordion]');
        this.accordions = new Set();
        this.nlAccordions.forEach(el => this.accordions.add(new SingleAccordion(el)));
        this.container.dispatchEvent(new CustomEvent('accordioninit', {
            detail: this,
        }));
    }

    /**
     * Close all accordions in set.
     */
    closeAll() {
        this.accordions.forEach(obj => obj.close());
    }
}

export default Accordions;
